<template>
  <div class="import-box import_new_wrap">
    <el-dialog title="导入数据" :visible.sync="dialogVisible" width="800px">
      <div class="import-dialog-box">
        <div class="import-dialog-title">
          <img src="../../../assets/icon/import_warning.png" alt="" />
          若导入数据已存在，那么信息将会覆盖，请谨慎操作。
        </div>
        <div class="import-dialog-item">
          <div class="import-step-title">1、导入前请先录入以下内容</div>
          <div class="dialog-input-box">
            <div class="dialog-input-title">
              <span style="color: red">*</span>导入企业
            </div>
            <el-select
              v-model="tenantGuid"
              placeholder="请选择"
              filterable
              style="width: 300px"
            >
              <el-option
                v-for="item in sendTenantList"
                :key="item.sendTenantGuid"
                :label="item.sendTenantName"
                :value="item.sendTenantGuid"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="import-dialog-item">
          <div class="import-step-title">2、选择准备好的文件导入</div>
          <div class="import-step-tip">
            当前支持xlsx、xls、xls、xlsm格式文件
          </div>
          <el-upload
            class="upload-demo t-left"
            action="#"
            multiple
            :limit="1"
            accept=".xlsx,.xsl,.xls,.xlsm"
            :before-upload="beforeUpload"
            :on-exceed="handleExceed"
            :http-request="changeFile"
            :file-list="fileList"
            :show-file-list="false"
          >
            <el-button
              size="mini"
              icon="el-icon-my-import"
              style="margin-top: 8px; margin-bottom: 0"
              type="importNew"
              v-loading.fullscreen.lock="fullscreenLoading"
              >导入文件</el-button
            >
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="importSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "BatchAdjustmentOrderDialog",
  data() {
    return {
      dialogVisible: false,
      tenantGuid: "",
      sendTenantList: [],
      fileList: [],
      fullscreenLoading: false,
    };
  },
  methods: {
    //导入确定
    importSure() {
      this.fileList = [];
      this.dialogVisible = false;
      this.$emit("getData", true);
    },
    open(data) {
      const { tenantGuid, sendTenantList } = data;
      this.tenantGuid = tenantGuid;
      this.sendTenantList = sendTenantList;
      this.dialogVisible = true;
    },
    //批量导入
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split(".");
      if (arr[1] !== "xls" && arr[1] !== "xlsx" && arr[1] !== "xlsm") {
        this.$message.error("上传文件只能是 excel/xls 格式!");
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    changeFile(file, fileList) {
      this.fileList = [];
      this.fullscreenLoading = true;
      const formData = new FormData();
      formData.append("file", file.file); //传文件
      formData.append("clientTenantGuid", this.tenantGuid);
      const url = `/${serverConfig.msPurchaseService}/sale-order/import`;
      this.api.postFile(url, formData).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
          return;
        }
        this.$emit("onChangeImportResult", res.data.data);
        this.$emit("onChangeShowImport", true);
        this.$emit("getData", true);
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
